import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'VatChargeability';
const ENDPOINT = `/vat-chargeabilities/`;

@Injectable({
    providedIn: 'root'
})
export class VatChargeabilityService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
